import _ArrowRightIcon from "@adsk/alloy-react-icon/es/lib/ArrowRightIcon";
import _CalendarFilledIcon from "@adsk/alloy-react-icon/es/lib/CalendarFilledIcon";
import _styled from "styled-components";
const _excluded = ["open", "value", "placeholder", "startDatePlaceholder", "endDatePlaceholder", "disabled", "error", "range", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC, { css } from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import FieldValue from './FieldValue';
import ToggleIcon from './ToggleIcon';
const StyledButton = styledC.button.withConfig({
  displayName: "Field__StyledButton",
  componentId: "sc-a2tyfh-0"
})(["display:flex;height:36px;width:300px;cursor:", ";padding:0px ", "px;align-items:center;outline:none;background-color:", ";border:1px solid ", ";border-radius:", "px;transition:", ";&:hover{box-shadow:", ";}&:focus{box-shadow:", ";border-color:", ";}&:active{box-shadow:", ";border-color:", ";}& svg{color:", ";}", " ", ""], _ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'default' : 'pointer';
}, theme.spacing.S, theme.tokens.colors.background.primary.value, theme.tokens.colors.border.value, theme.borderRadius.small, theme.transitions.create(['box-shadow', 'border-color']), theme.halos.hover, theme.halos.focus, theme.tokens.colors.border.focused.value, theme.halos.active, theme.tokens.colors.border.value, _ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? theme.tokens.colors.icon.inactive.value : theme.tokens.colors.icon.secondary.value;
}, _ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? css(["background-color:", ";border-color:", ";&:hover,&:focus,&:active:{border-color:", ";box-shadow:none;}"], theme.tokens.colors.background.neutral.inactive.value, theme.tokens.colors.border.inactive.value, theme.tokens.colors.border.inactive.value) : '';
}, _ref4 => {
  let {
    error
  } = _ref4;
  return error ? css(["border-color:", ";&:hover,&:focus,&:active:{border-color:", ";}"], theme.tokens.colors.border.error.value, theme.tokens.colors.border.error.value) : '';
});
var _StyledStyledButton = styledC(StyledButton).withConfig({
  displayName: "Field___StyledStyledButton",
  componentId: "sc-a2tyfh-1"
})(["", ""], p => p.$_css);
const StyledFieldValue = styledC(FieldValue).withConfig({
  displayName: "Field__StyledFieldValue",
  componentId: "sc-a2tyfh-2"
})(["margin:0 10px;display:block;", ""], theme.typography.ellipsis);
const Field = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
      open,
      value,
      placeholder,
      startDatePlaceholder,
      endDatePlaceholder,
      disabled,
      error,
      range,
      style
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded);
  const [startDate, endDate] = Array.isArray(value) ? value : [value];
  const rangeDatesSelected = range ? startDate && endDate : false;
  return /*#__PURE__*/React.createElement(_StyledStyledButton, _extends({
    type: "button",
    error: error,
    disabled: disabled,
    ref: ref
  }, props, {
    $_css: style
  }), /*#__PURE__*/React.createElement(_CalendarFilledIcon, {
    size: 16
  }), /*#__PURE__*/React.createElement(StyledFieldValue, {
    value: startDate,
    disabled: disabled,
    selecting: open && !rangeDatesSelected,
    placeholder: range ? startDatePlaceholder : placeholder,
    "data-testid": "DatePickerFieldValue-start"
  }), range && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ArrowRightIcon, null), /*#__PURE__*/React.createElement(StyledFieldValue, {
    value: endDate,
    disabled: disabled,
    selecting: open && !rangeDatesSelected,
    placeholder: endDatePlaceholder,
    "data-testid": "DatePickerFieldValue-end"
  })), /*#__PURE__*/React.createElement(ToggleIcon, {
    isOpen: !!open
  }));
});
Field.displayName = 'Field';
Field.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to display, should be the formatted date(s) string(s) */
  value: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  /** Placeholder to display when there is no value */
  placeholder: PropTypes.string,
  /** Passed to the field, startDatePlaceholder to display when there is no value */
  startDatePlaceholder: PropTypes.string,
  /** Passed to the field, endDatePlaceHolder to display when there is no value */
  endDatePlaceholder: PropTypes.string,
  /** Indicates whether the overlay is open */
  open: PropTypes.bool,
  /** Whether we should display range state */
  range: PropTypes.bool,
  /** Whether the field is disabled */
  disabled: PropTypes.bool,
  /** Whether the field should display error state */
  error: PropTypes.bool
};
export default Field;
//# sourceMappingURL=Field.js.map